import type { Subprofile } from '~publish/legacy/composer/composer/stores/types'

/**
 * The board id to send for a channel's current board selection.
 *
 * The selection is held as Buffer's id for the board while the API identifies a
 * board by the network's id, so the two must be translated here. `null` when
 * nothing is selected or the selection is no longer among the channel's boards
 * — the mapper then omits the field, which rejects a create and preserves the
 * stored board on an edit.
 */
export function selectedBoardServiceId(profile: {
  selectedSubprofileId: string | null
  subprofiles: Subprofile[]
}): string | null {
  const { selectedSubprofileId, subprofiles } = profile

  if (selectedSubprofileId === null) {
    return null
  }

  const board = subprofiles.find(
    (subprofile) => subprofile.id === selectedSubprofileId,
  )

  return board?.serviceId ?? null
}
